/* ══════════════════════════════════════════════════════════
   photo-wall-media.js
   Landing Redesign — Module 2 config file (EDIT THIS ONE, NOT photoWall.js)

   HOW TO USE:
   List file paths below. That's it — you never need to touch
   photoWall.js or photo-wall.css to add/remove/reorder media.

   - .webp / .jpg / .png / .avif → rendered as an image
   - .webm / .mp4                → rendered as an autoplaying,
                                    muted, looping video
   The extension alone decides which — no extra field to fill in.

   Pre-filled below with the exact 8 files your current Ken Burns
   background already uses (verified from index.html) — 6 images,
   2 videos, already matching your "exactly 2 video slots"
   requirement. Replace/reorder/add freely; this list is just a
   real, working starting point, not a placeholder.

   Distribution across the wall's 3 columns is automatic
   (round-robin — item 1→col A, item 2→col B, item 3→col C, item
   4→col A, ...), so you don't need to sort these into columns
   yourself either.
   ══════════════════════════════════════════════════════════ */

const PHOTO_WALL_MEDIA = [
  './images/galeria5/hMoxc77shs5eS42gnkl3xc.webp',
  './images/galeria2/DSC00242_3.webp',
  './Video/TEST_1._720p.webm',
  './images/galeria2/DSC00521.webp',
  './images/galeria1/4.webp',
  './images/galeria4/20180224013950_IMG_2165_2.webp',
  './images/galeria2/DSC01268.webp',
  './Video/3d_540p.webm',

  /* Add more below this line, same format, one per line: */
  // './images/galeria3/your-photo.webp',
];
